/* ===================================================
   OBEYTHECULTURE  SCRIPT
   Lenis + GSAP + Mega Menu (focus effect) + Cart
   =================================================== */

/* ---------- 1. LENIS SMOOTH SCROLL ---------- */
const lenis = new Lenis({
  lerp: 0.1,
  wheelMultiplier: 1,
  touchMultiplier: 2,
  normalizeWheel: true
});
window.lenis = lenis;



gsap.registerPlugin(ScrollTrigger);
lenis.on('scroll', ScrollTrigger.update);
gsap.ticker.add(time => lenis.raf(time * 1000));
// gsap.ticker.lagSmoothing(0); // removed for performance

/* ---------- 2. STICKY HEADER (logo colour swap, no bar) ---------- */
const header = document.getElementById('main-header');
window.addEventListener('scroll', () => {
  header.classList.toggle('scrolled', window.scrollY > 60);
}, { passive: true });

/* ---------- 3. TWO-TIER DYNAMIC MEGA MENU ----------
   ObeyTheCulture-style stateful navigation (vanilla-JS port of the
   React useState pattern):
     state.open          menu overlay visible
     state.activeParent  currently hovered parent category
   Parents WITHOUT subs act as standard links.            */

/* =======================================================
   NAV ARCHITECTURE
   Top bar: Home (link) | Shop (mega) | About (mega)
   Mega left column = children of the hovered top item.
   Mega right column = subs of the hovered left child.
   ======================================================= */

// Are we on the homepage? (used so "Home" smooth-scrolls instead of reloading)
const ON_HOME = /(^\/?$)|(\/index\.html$)/.test(location.pathname);

// Top-bar items  only 3 links. Mega items also carry a landing-page url.
const NAV_TOP = window.OTC_NAV_TOP || [];

// Two-level mega data keyed by top-nav mega label
const MEGA_DATA = window.OTC_MEGA_DATA || {};

// Flat sub-href lookup (for clicking right-column links)


const megaMenu    = document.getElementById('mega-menu');
const megaParents = document.getElementById('mega-parents');
const megaSubs    = document.getElementById('mega-subs');
const megaSubsEyebrow = document.getElementById('mega-subs-eyebrow');
const navList     = document.getElementById('nav-list');

const state = { open: false, activeMega: null, activeParent: null };
let closeTimeout = null;

/* ----- Render 3-item top navbar wrapped in .nav-pill ----- */
navList.innerHTML = `<div class="nav-pill">` + NAV_TOP.map(item => {
  if (!item.mega) {
    // Plain link  Home
    return `<li class="nav-item"><a class="nav-link" href="${item.href}">${item.label}</a></li>`;
  }
  return `<li class="nav-item"><button class="nav-link" data-mega="${item.mega}"${item.url ? ` data-url="${item.url}"` : ''} aria-expanded="false">${item.label}</button></li>`;
}).join('') + `</div>`;

const navLinks    = navList.querySelectorAll('.nav-link[data-mega]');
let   parentItems = []; // populated dynamically per openMenu()

/* ----- setState: activeParent  drives the right column ----- */
// ArrowRight icon (Lucide)
const ARROW_SVG = `<svg viewBox="0 0 24 24" fill="none" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>`;

/* ----- Render left column for a given mega key ----- */
function renderLeftColumn(megaKey) {
  const children = MEGA_DATA[megaKey] || [];
  megaParents.innerHTML = children.map(item =>
    `<button class="mega-parent" data-parent="${item.label}"${item.url ? ` data-url="${item.url}"` : ''}>` +
    `<span class="parent-arrow" aria-hidden="true">${ARROW_SVG}</span>` +
    `<span class="parent-label">${item.label}</span>` +
    `</button>`
  ).join('');
  // Refresh the live NodeList reference
  parentItems = Array.from(megaParents.querySelectorAll('.mega-parent'));
  // Bind left-column hover events
  parentItems.forEach(p => {
    p.addEventListener('mouseenter', () => setActiveParent(p.dataset.parent, megaKey));
    p.addEventListener('click', () => {
      // Parents with a data-url navigate to a real page (e.g. Editorial)
      if (p.dataset.url) { window.location.href = p.dataset.url; return; }
      setActiveParent(p.dataset.parent, megaKey);
    });
  });
}

/* ----- setState: activeParent  drives the right column ----- */
function setActiveParent(label, megaKey) {
  if (state.activeParent === label) return;
  state.activeParent = label;

  parentItems.forEach(p => p.classList.toggle('active', p.dataset.parent === label));

  const children = MEGA_DATA[megaKey || state.activeMega] || [];
  const item = children.find(d => d.label === label);
  if (item && item.subs && item.subs.length) {
    megaSubsEyebrow.textContent = item.label;
          megaSubs.innerHTML = item.subs.map(subItem => {
        let subLabel = typeof subItem === 'string' ? subItem : subItem.label;
        let subHref  = typeof subItem === 'string' ? item.href : subItem.url;
        return `<a href="${subHref}" class="mega-sub" tabindex="0">${subLabel}</a>`;
      }).join('');
    gsap.fromTo('.mega-sub',
      { opacity: 0, x: 18 },
      { opacity: 1, x: 0, duration: 0.38, stagger: 0.05, ease: 'power2.out', clearProps: 'opacity,transform' }
    );
  } else {
    megaSubsEyebrow.textContent = '';
    megaSubs.innerHTML = '';
  }
}

/* ----- setState: open  renders the correct left column for the mega key ----- */
function openMenu(megaKey) {
  if (closeTimeout) { clearTimeout(closeTimeout); closeTimeout = null; }

  const needsRebuild = state.activeMega !== megaKey;
  state.activeMega = megaKey;

  if (!state.open) {
    state.open = true;
    megaMenu.classList.add('open');
    megaMenu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    lenis.stop();
  }

  if (needsRebuild) {
    state.activeParent = null;
    megaSubsEyebrow.textContent = '';
    megaSubs.innerHTML = '';
    renderLeftColumn(megaKey);
    gsap.fromTo('.mega-parent',
      { opacity: 0, y: 26 },
      { opacity: 1, y: 0, duration: 0.5, stagger: 0.045, ease: 'power3.out', delay: 0.05, clearProps: 'opacity,transform' }
    );
    // Auto-activate first child so right column isn't empty
    const first = (MEGA_DATA[megaKey] || [])[0];
    if (first) setActiveParent(first.label, megaKey);
  }

  navLinks.forEach(l => {
    const isActive = l.dataset.mega === megaKey;
    l.classList.toggle('menu-active', isActive);
    l.setAttribute('aria-expanded', isActive ? 'true' : 'false');
  });
}

function closeMenu(immediate = false) {
  if (!state.open) return;
  const doClose = () => {
    state.open = false;
    state.activeMega = null;
    state.activeParent = null;
    megaMenu.classList.remove('open');
    megaMenu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    lenis.start();
    parentItems.forEach(p => p.classList.remove('active'));
    navLinks.forEach(l => {
      l.classList.remove('menu-active');
      l.setAttribute('aria-expanded', 'false');
    });
  };
  if (immediate) doClose();
  else closeTimeout = setTimeout(doClose, 130);
}

/* ----- Navbar triggers (Shop / About open their respective menus) ----- */
navLinks.forEach(btn => {
  btn.addEventListener('mouseenter', () => openMenu(btn.dataset.mega));
  btn.addEventListener('mouseleave', () => closeMenu());
  // Click navigates to the category landing page (hover still previews the mega).
  btn.addEventListener('click', () => {
    if (btn.dataset.url) { window.location.href = btn.dataset.url; return; }
    if (state.activeMega === btn.dataset.mega && state.open) closeMenu(true);
    else openMenu(btn.dataset.mega);
  });
});

megaMenu.addEventListener('mouseenter', () => {
  if (closeTimeout) { clearTimeout(closeTimeout); closeTimeout = null; }
});
megaMenu.addEventListener('mouseleave', () => closeMenu());

document.addEventListener('mousedown', e => {
  if (!megaMenu.contains(e.target) && !header.contains(e.target)) closeMenu(true);
});

document.addEventListener('keydown', e => {
  if (e.key === 'Escape') {
    closeMenu(true);
    if (cartDrawer && cartDrawer.classList.contains('open')) closeCart();
    if (typeof closeSearch === 'function') closeSearch();
    if (typeof closeAccount === 'function') closeAccount();
  }
});

/* ---------- MOBILE HAMBURGER MENU TOGGLE ---------- */
const menuBtn = document.getElementById('menu-btn');
const mobileNav = document.getElementById('mobile-nav');
const mobileNavOverlay = document.getElementById('mobile-nav-overlay');
let mobileNavOpen = false;

function closeMobileNav() {
  mobileNavOpen = false;
  mobileNav.classList.remove('open');
  mobileNav.setAttribute('aria-hidden', 'true');
  menuBtn.setAttribute('aria-expanded', 'false');
  menuBtn.classList.remove('is-active');
  document.body.style.overflow = '';
  if (typeof lenis !== 'undefined') lenis.start();
}

function openMobileNav() {
  mobileNavOpen = true;
  mobileNav.classList.add('open');
  mobileNav.setAttribute('aria-hidden', 'false');
  menuBtn.setAttribute('aria-expanded', 'true');
  menuBtn.classList.add('is-active');
  document.body.style.overflow = 'hidden';
  if (typeof lenis !== 'undefined') lenis.stop();
  // Close any open mega menu
  if (typeof closeMenu === 'function') closeMenu(true);
}

if (menuBtn && mobileNav) {
  menuBtn.addEventListener('click', () => {
    if (mobileNavOpen) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  });

  if (mobileNavOverlay) {
    mobileNavOverlay.addEventListener('click', closeMobileNav);
  }
}

// Ensure escape closes mobile nav too
document.addEventListener('keydown', e => {
  if (e.key === 'Escape' && mobileNavOpen) {
    closeMobileNav();
  }
});

/* ---------- 4. CART DRAWER (Functional localStorage Cart) ---------- */
const cartBtn     = document.getElementById('cart-btn');
const cartClose   = document.getElementById('cart-close');
const cartDrawer  = document.getElementById('cart-drawer');
const cartOverlay = document.getElementById('cart-overlay');
const cartPanel   = cartDrawer ? cartDrawer.querySelector('.cart-panel') : null;

// Initialize cart from localStorage

/* ---------- DISCOUNT CODE SYSTEM ---------- */
const OTC_DISCOUNT_CODE = (window.OTC_SETTINGS && window.OTC_SETTINGS.cartDiscountCode) ? window.OTC_SETTINGS.cartDiscountCode : 'OTCSELECT';
const OTC_DISCOUNT_DESC = (window.OTC_SETTINGS && window.OTC_SETTINGS.cartDiscountDesc) ? window.OTC_SETTINGS.cartDiscountDesc : 'Flat ₹2,490 pricing on all items';
const OTC_DISCOUNT_ENABLE = (window.OTC_SETTINGS && typeof window.OTC_SETTINGS.cartDiscountEnable !== 'undefined') ? window.OTC_SETTINGS.cartDiscountEnable : true;
const OTC_DISCOUNT_PRICE = 249000; // ₹2490 in paisa (Shopify stores prices in minor units)
const OTC_DISCOUNT_STORAGE_KEY = 'otc_active_discount';

function getActiveDiscount() {
  try { return localStorage.getItem(OTC_DISCOUNT_STORAGE_KEY) || ''; } catch(e) { return ''; }
}
function setActiveDiscount(code) {
  try { localStorage.setItem(OTC_DISCOUNT_STORAGE_KEY, code); } catch(e) {}
}
function removeActiveDiscount() {
  try { localStorage.removeItem(OTC_DISCOUNT_STORAGE_KEY); } catch(e) {}
}
function isDiscountActive() {
  return getActiveDiscount().toUpperCase() === OTC_DISCOUNT_CODE;
}

// Sync discount attributes to Shopify cart (read by Shiprocket at checkout)
async function syncDiscountToCart(active) {
  try {
    if (active) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: { discount_code: OTC_DISCOUNT_CODE, cod_disabled: 'true' },
          note: 'Discount code: ' + OTC_DISCOUNT_CODE + ' — COD disabled'
        })
      });
    } else {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: { discount_code: '', cod_disabled: '' },
          note: ''
        })
      });
    }
  } catch(e) { console.warn('Failed to sync discount to cart:', e); }
}

// Apply discount code (called from cart drawer input)
window.otcApplyDiscount = async function() {
  const input = document.getElementById('otc-discount-input');
  const msg = document.getElementById('otc-discount-msg');
  if (!input) return;
  const code = input.value.trim().toUpperCase();
  if (code === OTC_DISCOUNT_CODE) {
    setActiveDiscount(code);
    await syncDiscountToCart(true);
    renderCart();
  } else {
    if (msg) {
      msg.textContent = 'Invalid discount code';
      msg.style.color = '#e53935';
    }
    setTimeout(() => { if (msg) msg.textContent = ''; }, 3000);
  }
};

// Remove discount code
window.otcRemoveDiscount = async function() {
  removeActiveDiscount();
  await syncDiscountToCart(false);
  renderCart();
};

async function fetchShopifyCart() {
  const res = await fetch('/cart.js');
  return await res.json();
}

window.updateCartItem = async function(key, quantity) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity })
  });
  renderCart();
};

async function renderCart() {
  const cart = await fetchShopifyCart();
  const discountActive = isDiscountActive();
  
  const countEls = document.querySelectorAll('.cart-count');
  countEls.forEach(el => el.textContent = cart.item_count);

  if (!cartPanel) return;

  // Marquee content changes based on discount state
  const marqueeText = discountActive
    ? 'PREPAID ONLY &nbsp;&nbsp;&bull;&nbsp;&nbsp; COD NOT AVAILABLE &nbsp;&nbsp;&bull;&nbsp;&nbsp; PREPAID ONLY &nbsp;&nbsp;&bull;&nbsp;&nbsp; COD NOT AVAILABLE'
    : 'COD AVAILABLE &nbsp;&nbsp;&bull;&nbsp;&nbsp; COD AVAILABLE &nbsp;&nbsp;&bull;&nbsp;&nbsp; COD AVAILABLE &nbsp;&nbsp;&bull;&nbsp;&nbsp; COD AVAILABLE';
  const marqueeStyle = discountActive
    ? 'background: #b71c1c; color: #fff;'
    : 'background: var(--ink); color: var(--paper);';

  if (cart.item_count === 0) {
    cartPanel.innerHTML = `
      <div class="cart-header">
        <span class="cart-title">YOUR BAG</span>
        <button class="cart-close" aria-label="Close cart" onclick="closeCart()">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
      </div>
        <div class="cart-marquee" style="${marqueeStyle} padding: 6px 0; font-family: var(--sans); font-size: 10px; font-weight: 600; letter-spacing: 0.2em; text-transform: uppercase; overflow: hidden; white-space: nowrap; border-top: 1px solid rgba(255,255,255,0.1); border-bottom: 1px solid rgba(255,255,255,0.1);">
          <div style="display: inline-block; padding-left: 100%; animation: cartMarquee 12s linear infinite;">
            ${marqueeText}
          </div>
        </div>
        <style>@keyframes cartMarquee { 0% { transform: translate(0, 0); } 100% { transform: translate(-100%, 0); } }</style>
      <div class="cart-empty" style="flex: 1; display: flex; flex-direction: column; justify-content: center; padding: 40px 28px;">
        <h3 class="cart-empty-title" style="font-family: var(--serif); font-size: 32px; font-weight: 400; margin-bottom: 12px;">Your bag is empty</h3>
        <p class="cart-empty-sub" style="font-family: var(--sans); font-size: 13px; color: var(--stone); margin-bottom: 40px;">The culture is waiting. Start with a signature piece.</p>
        <a href="/pages/shop" class="btn btn-dark btn-block cart-shop-women" onclick="closeCart()">Enter the Shop</a>
      </div>
    `;
    return;
  }

  const formatter = new Intl.NumberFormat('en-IN', { style: 'currency', currency: cart.currency || 'INR', minimumFractionDigits: 0 });

  // Calculate subtotal excluding free gifts
  let rawTotal = 0;
  let discountedTotal = 0;
  cart.items.forEach(item => {
    const isGift = String(item.variant_id) === '45668771135623' || (item.properties && item.properties._free_gift === 'true');
    if (!isGift) {
      rawTotal += item.price * item.quantity;
      const effectivePrice = (discountActive && item.price > OTC_DISCOUNT_PRICE) ? OTC_DISCOUNT_PRICE : item.price;
      discountedTotal += effectivePrice * item.quantity;
    }
  });

  // Savings line (when discount is active and there are actual savings)
  const totalSavings = rawTotal - discountedTotal;
  const savingsHTML = (discountActive && totalSavings > 0) ? `
    <div style="display: flex; justify-content: space-between; margin-bottom: 8px; font-family: var(--sans); font-size: 12px; color: #2e7d32; font-weight: 500;">
      <span>You save</span>
      <span>-${formatter.format(totalSavings / 100)}</span>
    </div>` : '';

  // Free Hanger Progress Bar
  const HANGER_THRESHOLD = 400000; // ₹4,000 in paise
  const currentTotal = discountActive ? discountedTotal : rawTotal;
  const progressPercent = Math.min(100, (currentTotal / HANGER_THRESHOLD) * 100);
  const amountLeft = Math.max(0, (HANGER_THRESHOLD - currentTotal) / 100);
  
  const progressText = amountLeft > 0 
    ? `${formatter.format(amountLeft)} away from a free hanger` 
    : `\u2714 Free hanger unlocked!`;

  const progressBarHTML = `
    <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px;">
      <div style="flex: 1; height: 3px; background: rgba(128,128,128,0.2); border-radius: 3px; overflow: hidden;">
        <div style="width: ${progressPercent}%; height: 100%; background: var(--ink); border-radius: 3px; transition: width 0.5s ease;"></div>
      </div>
      <span style="font-family: var(--sans); font-size: 10px; color: var(--ink); opacity: 0.7; white-space: nowrap;">${progressText}</span>
    </div>
  `;

  cartPanel.innerHTML = `
    <style>@keyframes cartMarquee { 0% { transform: translate(0, 0); } 100% { transform: translate(-100%, 0); } }</style>
    <div class="cart-header">
      <span class="cart-title">YOUR BAG (${cart.item_count})</span>
      <button class="cart-close" aria-label="Close cart" onclick="closeCart()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>
    <div class="cart-marquee" style="${marqueeStyle} padding: 6px 0; font-family: var(--sans); font-size: 10px; font-weight: 600; letter-spacing: 0.2em; text-transform: uppercase; overflow: hidden; white-space: nowrap;">
      <div style="display: inline-block; padding-left: 100%; animation: cartMarquee 12s linear infinite;">
        ${marqueeText}
      </div>
    </div>

    <div class="cart-items" style="flex: 1; min-height: 0; overflow-y: auto; -webkit-overflow-scrolling: touch; padding: 20px 24px;">
      ${[...cart.items].filter(item => {
        const isGift = String(item.variant_id) === '45686971826311' || (item.properties && item.properties._free_gift === 'true');
        if (isGift && currentTotal < HANGER_THRESHOLD) return false;
        return true;
      }).sort((a, b) => {
        const isGiftA = String(a.variant_id) === '45686971826311' || (a.properties && a.properties._free_gift === 'true');
        const isGiftB = String(b.variant_id) === '45686971826311' || (b.properties && b.properties._free_gift === 'true');
        if (isGiftA && !isGiftB) return 1;
        if (!isGiftA && isGiftB) return -1;
        return 0;
      }).map((item) => {
        const isDiscounted = discountActive && item.price > OTC_DISCOUNT_PRICE;
        const displayPrice = isDiscounted ? OTC_DISCOUNT_PRICE : item.price;
        const priceHTML = isDiscounted
          ? `<span style="font-size: 13px;"><span style="text-decoration: line-through; opacity: 0.45; margin-right: 6px;">${formatter.format(item.price / 100)}</span><span style="color: #2e7d32; font-weight: 600;">${formatter.format(displayPrice / 100)}</span></span>`
          : `<span style="font-size: 13px;">${formatter.format(item.price / 100)}</span>`;
        return `
        <div class="cart-item" data-key="${item.key}" style="display: flex; gap: 16px; margin-bottom: 24px;">
          <img src="${item.image}" alt="${item.product_title}" style="width: 80px; height: 100px; object-fit: cover;">
          <div class="cart-item-info" style="flex: 1; display: flex; flex-direction: column; font-family: var(--sans);">
            <div style="display: flex; justify-content: space-between; margin-bottom: 4px;">
              <span style="font-size: 13px; font-weight: 500;">${item.product_title}</span>
              ${priceHTML}
            </div>
            <span style="font-size: 11px; color: var(--stone); margin-bottom: auto;">${item.variant_title ? item.variant_title : ''}</span>
            <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 12px;">
              <div style="display: flex; align-items: center; border: 1px solid var(--line); border-radius: 4px;">
                <button onclick="updateCartItem('${item.key}', ${item.quantity - 1})" style="padding: 4px 8px; background: none; border: none; cursor: pointer;">-</button>
                <span style="font-size: 12px; padding: 0 8px;">${item.quantity}</span>
                <button onclick="updateCartItem('${item.key}', ${item.quantity + 1})" style="padding: 4px 8px; background: none; border: none; cursor: pointer;">+</button>
              </div>
              <button onclick="updateCartItem('${item.key}', 0)" style="font-size: 10px; text-decoration: underline; background: none; border: none; cursor: pointer; color: var(--stone-dark);">Remove</button>
            </div>
          </div>
        </div>
      `}).join('')}
    </div>
    <div class="cart-footer" style="padding: 12px 24px 40px; border-top: 1px solid var(--line-soft); background: var(--paper);">
      ${progressBarHTML}
      ${savingsHTML}
      <div style="display: flex; justify-content: space-between; margin-bottom: 6px; font-family: var(--sans); font-size: 14px; font-weight: 500;">
        <span>Subtotal</span>
        <span>${discountActive ? formatter.format(discountedTotal / 100) : formatter.format(rawTotal / 100)}</span>
      </div>
      <p style="font-family: var(--sans); font-size: 10px; color: var(--stone); margin-bottom: 12px; text-align: center;">Shipping & taxes at checkout</p>
      <div class="shiprocket-headless" data-type="mini-cart"></div>
      <a href="/checkout" class="btn btn-dark btn-block" style="width: 100%; display:none; text-align: center; text-decoration: none; padding: 12px 0;">Checkout</a>
    </div>
  `;
}
window.openCart = function() {
  if (cartDrawer) {
    cartDrawer.classList.add('open');
    document.body.style.overflow = 'hidden';
    if (typeof lenis !== 'undefined') lenis.stop();
  }
};

window.closeCart = function() {
  if (cartDrawer) {
    cartDrawer.classList.remove('open');
  }
  document.body.style.overflow = '';
  if (typeof lenis !== 'undefined') lenis.start();
};

if (cartBtn) cartBtn.addEventListener('click', window.openCart);
if (cartOverlay) cartOverlay.addEventListener('click', window.closeCart);

document.body.addEventListener('click', (e) => {
  if (e.target.closest('.cart-close') || e.target.closest('#cart-close')) {
    window.closeCart();
  }
});

/* ---------- 4b. SEARCH OVERLAY ---------- */
const searchBtn     = document.getElementById('search-btn');
const searchOverlay = document.getElementById('search-overlay');
const searchClose   = document.getElementById('search-close');
const searchForm    = document.getElementById('search-form');
const searchInput   = document.getElementById('search-input');

function openSearch() {
  if (!searchOverlay) return;
  searchOverlay.classList.add('open');
  searchOverlay.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  if (typeof lenis !== 'undefined') lenis.stop();
  setTimeout(() => searchInput && searchInput.focus(), 120);
}
function closeSearch() {
  if (!searchOverlay) return;
  searchOverlay.classList.remove('open');
  searchOverlay.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
  if (typeof lenis !== 'undefined') lenis.start();
}
if (searchBtn)   searchBtn.addEventListener('click', openSearch);
if (searchClose) searchClose.addEventListener('click', closeSearch);
if (searchForm) {
  searchForm.addEventListener('submit', e => {
    e.preventDefault();
    const q = (searchInput && searchInput.value || '').trim();
    // Hand the query to the shop page (it reads ?q= to filter).
    window.location.href = q ? `/pages/shop?q=${encodeURIComponent(q)}` : '/pages/shop';
  });
}

/* ---------- 4c. ACCOUNT DRAWER ---------- */
const accountBtn     = document.getElementById('account-btn');
const accountDrawer  = document.getElementById('account-drawer');
const accountClose   = document.getElementById('account-close');
const accountOverlay = document.getElementById('account-overlay');
function openAccount() {
  if (!accountDrawer) return;
  accountDrawer.classList.add('open');
  accountDrawer.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  if (typeof lenis !== 'undefined') lenis.stop();
}
function closeAccount() {
  if (!accountDrawer) return;
  accountDrawer.classList.remove('open');
  accountDrawer.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
  if (typeof lenis !== 'undefined') lenis.start();
}
if (accountBtn)     accountBtn.addEventListener('click', openAccount);
if (accountClose)   accountClose.addEventListener('click', closeAccount);
if (accountOverlay) accountOverlay.addEventListener('click', closeAccount);

// Toggle between "Sign in" and "Create account" copy.
// Delegated so it keeps working no matter how many times the alt-line re-renders.
let accountMode = 'signin';
if (accountDrawer) {
  accountDrawer.addEventListener('click', e => {
    if (!e.target.closest('#account-toggle')) return;
    const welcome = document.querySelector('.account-welcome');
    const sub     = document.querySelector('.account-sub');
    const submit  = document.getElementById('account-submit');
    const altText = document.querySelector('.account-alt');
    accountMode = accountMode === 'signin' ? 'register' : 'signin';
    if (accountMode === 'register') {
      if (welcome) welcome.textContent = 'Join the house.';
      if (sub)     sub.textContent = 'Create an account for early access, order history and private drops.';
      if (submit)  submit.textContent = 'Create account';
      if (altText) altText.innerHTML = 'Already a member? <button type="button" id="account-toggle">Sign in</button>';
    } else {
      if (welcome) welcome.textContent = 'Welcome back.';
      if (sub)     sub.textContent = 'Sign in for early access to drops, order history and private releases.';
      if (submit)  submit.textContent = 'Sign in';
      if (altText) altText.innerHTML = 'New here? <button type="button" id="account-toggle">Create an account</button>';
    }
  });
}

// Account form submit (mock)  referenced inline by chrome.js / index.html.
function handleAccount(e) {
  e.preventDefault();
  const submit = document.getElementById('account-submit');
  if (!submit) return;
  const label = submit.textContent;
  submit.textContent = accountMode === 'register' ? 'Account created ' : 'Signed in ';
  e.target.reset();
  setTimeout(() => { submit.textContent = label; closeAccount(); }, 1800);
}
window.handleAccount = handleAccount;

/* ---------- 5. SHOP TABS (generic by data-grid) ---------- */
const tabBtns = document.querySelectorAll('.tab-btn');
const grids   = document.querySelectorAll('.product-grid[data-grid]');
tabBtns.forEach(btn => {
  btn.addEventListener('click', () => {
    tabBtns.forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    grids.forEach(g => g.classList.toggle('hidden', g.dataset.grid !== btn.dataset.tab));
    const active = document.querySelector('.product-grid:not(.hidden)');
    if (active) {
      gsap.fromTo(active.querySelectorAll('.product-card'),
        { opacity: 0, y: 24 },
        { opacity: 1, y: 0, duration: 0.5, stagger: 0.06, ease: 'power2.out', clearProps: 'opacity,transform' });
    }
  });
});

/* ---------- 6. ADD TO BAG (minimal "+" quick-add) ---------- */
document.querySelectorAll('.pcard-add, .capcard-add, .flat-add').forEach(btn => {
  btn.addEventListener('click', e => {
    e.stopPropagation();
    e.preventDefault();
    if (btn.dataset.busy) return;
    btn.dataset.busy = '1';
    const original = btn.textContent;
    btn.textContent = '';
    btn.style.background = 'var(--ink)';
    btn.style.color = 'var(--paper)';
    btn.style.borderColor = 'var(--ink)';
    const countEl = document.querySelector('.cart-count');
    if (countEl) countEl.textContent = parseInt(countEl.textContent || 0) + 1;
    setTimeout(() => {
      btn.textContent = original;
      btn.style.background = '';
      btn.style.color = '';
      btn.style.borderColor = '';
      delete btn.dataset.busy;
    }, 1400);
  });
});

/* Stop bookmark clicks from triggering the card's onclick navigation */
document.querySelectorAll('.shop-bookmark').forEach(btn => {
  btn.addEventListener('click', e => e.stopPropagation());
});

/* ---------- 7. EDITORIAL SHOWCASE TABS ---------- */
function setupShowcaseTabs(tabListId, imgId) {
  const tabs = document.querySelectorAll(`#${tabListId} .tab-item`);
  const img  = document.getElementById(imgId);
  if (!tabs.length || !img) return;
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      if (tab.dataset.img) {
        gsap.to(img, { opacity: 0, scale: 0.98, duration: 0.3, ease: 'power2.in', onComplete: () => {
          img.src = tab.dataset.img;
          gsap.to(img, { opacity: 1, scale: 1, duration: 0.45, ease: 'power2.out' });
        }});
      }
    });
  });
}
setupShowcaseTabs('editorial-tabs', 'editorial-img');

/* ---------- 8. NEWSLETTER ---------- */
function handleNewsletter(e) {
  e.preventDefault();
  const input = document.getElementById('email-input');
  const btn   = document.getElementById('newsletter-submit');
  if (!input || !btn) return;
  btn.innerHTML = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><polyline points="20 6 9 17 4 12"/></svg>`;
  input.value = ''; input.placeholder = "You're on the list.";
  setTimeout(() => {
    btn.innerHTML = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M5 12h14M12 5l7 7-7 7"/></svg>`;
    input.placeholder = 'Your email';
  }, 3000);
}
window.handleNewsletter = handleNewsletter;

/* ---------- 9. CONTACT FORM ---------- */
function handleContact(e) {
  e.preventDefault();
  const btn = document.getElementById('contact-submit');
  if (!btn) return;
  const label = btn.textContent;
  btn.textContent = 'Message sent ';
  e.target.reset();
  setTimeout(() => { btn.textContent = label; }, 3200);
}
window.handleContact = handleContact;

/* ---------- 10. GSAP SCROLL ANIMATIONS ---------- */
    // Hero parallax removed in favor of CSS position: fixed
// Generic fade-up for section headings & copy blocks
gsap.utils.toArray('.section-title, .display-title, .manifesto-text, .lede, .section-sub').forEach(el => {
  gsap.fromTo(el,
    { opacity: 0, y: 44 },
    { opacity: 1, y: 0, duration: 1, ease: 'power3.out',
      scrollTrigger: { trigger: el, start: 'top 88%', toggleActions: 'play none none none' } });
});

// Grid stagger reveals
gsap.utils.toArray('.product-grid:not(.hidden), .arrivals-row, .collection-grid, .collectables-grid, .journal-grid').forEach(grid => {
  gsap.fromTo(grid.children,
    { opacity: 0, y: 36 },
    { opacity: 1, y: 0, duration: 0.8, stagger: 0.1, ease: 'power2.out',
      scrollTrigger: { trigger: grid, start: 'top 84%', toggleActions: 'play none none none' } });
});

// EC Grid Reveals
gsap.utils.toArray('.ec-grid-reveal').forEach((grid) => {
  const cards = grid.querySelectorAll('.ec-card');
  if (cards.length === 0) return;
  gsap.fromTo(cards,
    { y: 36, opacity: 0 },
    {
      y: 0, opacity: 1,
      duration: 0.65,
      stagger: 0.08,
      ease: 'power3.out',
      scrollTrigger: { trigger: grid, start: 'top 82%' }
    }
  );
});

// EC Banner Parallax
gsap.utils.toArray('.ec-banner-reveal').forEach((banner) => {
  const img = banner.querySelector('img');
  if (img) {
    gsap.fromTo(img,
      { yPercent: -8 },
      {
        yPercent: 8,
        ease: 'none',
        scrollTrigger: { trigger: banner, scrub: 1.5, start: 'top bottom', end: 'bottom top' }
      }
    );
  }
  const content = banner.querySelector('.ec-banner-content');
  if (content) {
    gsap.fromTo(content,
      { y: 30, opacity: 0 },
      { y: 0, opacity: 1, duration: 1, ease: 'power3.out',
        scrollTrigger: { trigger: banner, start: 'top 70%' }
      }
    );
  }
});

// EC Header Reveals
gsap.utils.toArray('.ec-header').forEach((hdr) => {
  const label = hdr.querySelector('.ec-label');
  if (!label) return;
  // A minimal, elegant reveal with letter spacing expansion
  gsap.fromTo(label,
    { opacity: 0, y: 20, letterSpacing: '0em' },
    { opacity: 1, y: 0, letterSpacing: '0.25em', duration: 1.2, ease: 'power3.out',
      scrollTrigger: { trigger: hdr, start: 'top 85%' }
    }
  );
});

// Media reveals
gsap.utils.toArray('.featured-media, .split-media, .about-media, .limited-bg, .showcase-image-wrap').forEach(el => {
  gsap.fromTo(el,
    { opacity: 0, scale: 1.04 },
    { opacity: 1, scale: 1, duration: 1.2, ease: 'power2.out',
      scrollTrigger: { trigger: el, start: 'top 90%', toggleActions: 'play none none none' } });
});

// Newsletter card
gsap.fromTo('.newsletter-card',
  { opacity: 0, y: 40 },
  { opacity: 1, y: 0, duration: 0.9, ease: 'power3.out',
    scrollTrigger: { trigger: '.footer-newsletter', start: 'top 88%', toggleActions: 'play none none none' } });

/* ---------- 11. SMOOTH ANCHOR SCROLLING ---------- */
document.querySelectorAll('a[href^="#"]').forEach(a => {
  a.addEventListener('click', e => {
    const href = a.getAttribute('href');
    if (href === '#' || href.length < 2) return;
    const target = document.querySelector(href);
    if (target) {
      e.preventDefault();
      closeMenu(true);
      lenis.scrollTo(target, { offset: href === '#top' ? -200 : -90, duration: 1.5 });
    }
  });
});

/* ---------- 12. HERO REVEAL SEQUENCE ----------
   The hero image starts zoomed in (via CSS). 
   On load, we remove .is-loading to let it settle and reveal the navbar. */
(() => {
  let started = false;
  const reveal = () => {
    if (started) return;
    started = true;
    
    setTimeout(() => {
      document.body.classList.remove('is-loading');
      document.body.style.overflow = '';
      
      // Stop the CSS transition from fighting with GSAP parallax later
      setTimeout(() => { 
        const heroImg = document.querySelector('.hero-image'); 
        if(heroImg) heroImg.style.transition = 'none'; 
      }, 2200);
    }, 300);
  };

  if (document.readyState === 'complete') {
    reveal();
  } else {
    window.addEventListener('load', reveal);
  }
  // safety fallback
  setTimeout(reveal, 6000);
})();

/* ---------- 13. STORIES MODAL ---------- */
(() => {
  const trigger = document.getElementById('story-trigger');
  const modal = document.getElementById('story-modal');
  if (!trigger || !modal) return;

  const closeBtn = document.getElementById('story-close');
  const prevBtn = document.getElementById('story-prev');
  const nextBtn = document.getElementById('story-next');
  const slides = Array.from(modal.querySelectorAll('.story-slide'));
  const segs = Array.from(modal.querySelectorAll('.story-seg'));
  let index = 0;
  let autoTimer = null;
  const DURATION = 5000;

  function render() {
    slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
    segs.forEach((seg, i) => {
      seg.classList.toggle('is-done', i < index);
      seg.classList.toggle('is-active', i === index);
    });
  }

  function scheduleNext() {
    clearTimeout(autoTimer);
    autoTimer = setTimeout(() => go(index + 1), DURATION);
  }

  function go(next) {
    if (next < 0) next = 0;
    if (next >= slides.length) { close(); return; }   // past the last  close
    index = next;
    render();
    scheduleNext();
  }

  function open() {
    modal.classList.remove('hidden');
    // next frame so the opacity transition runs
    requestAnimationFrame(() => modal.classList.add('is-open'));
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (typeof lenis !== 'undefined') lenis.stop();
    index = 0;
    render();
    scheduleNext();
  }

  function close() {
    clearTimeout(autoTimer);
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (typeof lenis !== 'undefined') lenis.start();
    setTimeout(() => modal.classList.add('hidden'), 400);  // after fade-out
    // reset progress fill so re-opening replays cleanly
    segs.forEach(seg => seg.classList.remove('is-active', 'is-done'));
  }

  trigger.addEventListener('click', open);
  closeBtn.addEventListener('click', close);
  prevBtn.addEventListener('click', () => go(index - 1));
  nextBtn.addEventListener('click', () => go(index + 1));
  modal.addEventListener('click', e => { if (e.target === modal) close(); });
  document.addEventListener('keydown', e => {
    if (modal.classList.contains('hidden')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowRight') go(index + 1);
    else if (e.key === 'ArrowLeft') go(index - 1);
  });
})();


  // Dynamic Footer Reveal
  if (document.querySelector('.uf')) {
    const footerTl = gsap.timeline({
      scrollTrigger: {
        trigger: '.uf',
        start: 'top 85%',
      }
    });

    footerTl.fromTo('.uf-grid > *', { y: 28, opacity: 0 }, { y: 0, opacity: 1, duration: 0.7, ease: 'power3.out', stagger: 0.08 })
            .fromTo('.uf-base', { y: 16, opacity: 0 }, { y: 0, opacity: 1, duration: 0.6, ease: 'power3.out' }, "-=0.4");
  }

/* ---------- 14. DARK MODE TOGGLE ---------- */
(() => {
  const applyTheme = (isDark) => {
    if (isDark) {
      document.documentElement.classList.add('dark-mode');
    } else {
      document.documentElement.classList.remove('dark-mode');
    }
    // Update all theme toggles on the page
    document.querySelectorAll('#theme-toggle').forEach(btn => {
      const lightIcon = btn.querySelector('#theme-toggle-light');
      const darkIcon = btn.querySelector('#theme-toggle-dark');
      if (lightIcon) lightIcon.style.display = isDark ? 'inline-block' : 'none';
      if (darkIcon) darkIcon.style.display = isDark ? 'none' : 'inline-block';
    });
  };

  const savedTheme = localStorage.getItem('theme');
  const systemDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  if (savedTheme === 'dark' || (!savedTheme && systemDark)) {
    applyTheme(true);
  } else {
    applyTheme(false);
  }

  // Use event delegation for #theme-toggle buttons
  document.body.addEventListener('click', (e) => {
    const btn = e.target.closest('#theme-toggle');
    if (btn) {
      const isDark = !document.documentElement.classList.contains('dark-mode');
      localStorage.setItem('theme', isDark ? 'dark' : 'light');
      applyTheme(isDark);
    }
  });
})();

/* ---------- 15. PAGE TRANSITION (PRELOADER) ---------- */
(() => {
  // Inject the preloader HTML if it doesn't exist
  if (!document.getElementById('exit-preloader')) {
    document.body.insertAdjacentHTML('beforeend', `
      <div id="exit-preloader" style="position: fixed; inset: 0; z-index: 999999; background: var(--paper); opacity: 0; pointer-events: none; transition: opacity 0.3s cubic-bezier(0.22, 1, 0.36, 1);"></div>
    `);
  }

  document.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', e => {
      const href = link.getAttribute('href');
      const target = link.getAttribute('target');
      
      // Ignore invalid, blank, anchor, or external links
      if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || target === '_blank') return;
      
      // For normal internal links, show preloader then navigate
      e.preventDefault();
      const preloader = document.getElementById('exit-preloader');
      if (preloader) {
        preloader.style.pointerEvents = 'all';
        gsap.to(preloader, {
          opacity: 1,
          duration: 0.3,
          ease: 'power2.out',
          onComplete: () => {
            window.location.href = href;
          }
        });
      } else {
        window.location.href = href;
      }
    });
  });
})();

/* ---------- 16. SEAMLESS FLIP ANIMATION (Product Detail) ---------- */
(() => {
  let activeCard = null;
  let activeCloneWrapper = null;

  document.body.addEventListener('click', (e) => {
    // Reusable class system for FLIP triggers
    const card = e.target.closest('.js-flip-trigger') || e.target.closest('.blu-card');
    if (!card) return;

    // Safety guard: if popup mode is disabled via Theme Settings, navigate to product page instead
    if (window.OTC_SETTINGS && window.OTC_SETTINGS.productPopupEnable === false) {
      const handle = card.dataset.id;
      if (handle) {
        window.location.href = '/products/' + handle;
      }
      return;
    }
    
    if (activeCloneWrapper) return; // Prevent double-clicks from spawning stuck clones!

    if (e.target.closest('button')) return;

    // 1. Get initial state
    activeCard = card;
    window.__otcActiveProductHandle = card.dataset.id || '';
    const imgWrap = card.querySelector('.blu-card-img-wrap') || card.querySelector('.flip-img-wrap') || card.querySelector('.blu-sg-img-wrap');
    const img = card.querySelector('.blu-card-img--front') || card.querySelector('img');
    if (!img || !imgWrap) return;

    const rect = imgWrap.getBoundingClientRect();
    
    // 2. Setup the clone wrapper and image
    activeCloneWrapper = document.createElement('div');
    activeCloneWrapper.className = 'pdm-flip-clone-wrapper';
    activeCloneWrapper.style.top = rect.top + 'px';
    activeCloneWrapper.style.left = rect.left + 'px';
    activeCloneWrapper.style.width = rect.width + 'px';
    activeCloneWrapper.style.height = rect.height + 'px';

    const activeCloneImg = document.createElement('img');
    activeCloneImg.src = img.src;
    activeCloneImg.className = 'pdm-flip-clone-img';
    
    activeCloneWrapper.appendChild(activeCloneImg);
    document.body.appendChild(activeCloneWrapper);

    // 3. Populate modal data from dataset
    const title = card.dataset.name || 'Premium Item';
    const price = card.dataset.priceStr || 'RS. 10,800';
    
    const pdmTitle = document.getElementById('pdm-title');
    const pdmPrice = document.getElementById('pdm-price');
    const pdmDesc  = document.getElementById('pdm-desc');
    if (pdmTitle) pdmTitle.innerText = title;
    if (pdmPrice) pdmPrice.innerText = price;

    // --- Start Pixel Tracking ---
    try {
      const cleanPrice = parseFloat(price.replace(/[^0-9.-]+/g, '')) || 0;
      const variantIdStr = card.dataset.variantId || card.dataset.id || '';
      
      if (typeof fbq === 'function') {
        fbq('track', 'ViewContent', {
          content_name: title,
          content_ids: [variantIdStr],
          content_type: 'product',
          value: cleanPrice,
          currency: 'INR'
        });
      }
      if (typeof gtag === 'function') {
        gtag('event', 'view_item', {
          items: [{
            item_id: variantIdStr,
            item_name: title,
            price: cleanPrice
          }]
        });
      }
    } catch (err) {
      console.warn('Pixel tracking blocked or failed:', err);
    }
    // --- End Pixel Tracking ---

    // Inject the REAL product description from Shopify
    if (pdmDesc) {
      const rawDesc = card.dataset.desc || '';
      if (rawDesc) {
        pdmDesc.innerHTML = rawDesc;
      } else {
        pdmDesc.innerHTML = '<p>No description available.</p>';
      }
    }
    
    // Setup sizes
    const sizeSelector = document.getElementById('pdm-size-selector');
    const addBtn = document.getElementById('pdm-add-btn');
    if (sizeSelector && addBtn) {
      sizeSelector.style.display = 'none';
      sizeSelector.innerHTML = '';
      addBtn.innerText = 'Add to Cart';
      
      const sizesStr = card.dataset.sizes;
      if (sizesStr) {
        try {
          const sizes = JSON.parse(sizesStr);
          if (sizes.length > 0) {
            sizeSelector.style.display = 'flex';
          }
          sizes.forEach(sz => {
            const btn = document.createElement('button');
            btn.className = 'pdm-size-btn';
            btn.innerText = sz.name;
            btn.dataset.variantId = sz.id || '';
            if (!sz.available) {
              btn.disabled = true;
              btn.style.opacity = '0.4';
              btn.style.textDecoration = 'line-through';
              btn.style.cursor = 'not-allowed';
            } else {
              btn.onclick = () => {
                sizeSelector.querySelectorAll('.pdm-size-btn').forEach(b => b.classList.remove('selected'));
                btn.classList.add('selected');
              };
            }
            sizeSelector.appendChild(btn);
          });
        } catch(e) { console.error('Sizes JSON error', e); }
      }
    }
    
    // Setup the close button thumbnail
    const thumbImg = document.getElementById('pdm-close-thumb');
    if (thumbImg) thumbImg.src = img.src;

    // Setup slider instead of thumbnails
    const hoverImg = card.querySelector('.blu-card-img--back');
    const hoverSrc = hoverImg ? hoverImg.src : img.src;
    const thumbsContainer = document.getElementById('pdm-thumbnails');
    if (thumbsContainer) {
      thumbsContainer.style.display = 'none';
    }
    
    // Get all images
    const imagesStr = card.dataset.images;
    let imagesArr = [];
    if (imagesStr) {
      try {
        imagesArr = JSON.parse(imagesStr);
      } catch(e) {}
    }
    if (imagesArr.length === 0) {
      imagesArr = [img.src, hoverSrc];
    }
    
    imagesArr = [...new Set(imagesArr)];

    // Shopify CDN: upscale from 800x to 1200x for crisp desktop rendering
    imagesArr = imagesArr.map(url => url.replace(/_800x\./g, '_1200x.'));

    // Preload all product images into browser cache for instant slider navigation
    imagesArr.forEach(url => { const preload = new Image(); preload.src = url; });

    if (imagesArr.length > 1) {
      let currentIndex = 0;
      
      const sliderUI = document.createElement('div');
      sliderUI.className = 'pdm-slider-ui';
      
      const prevBtn = document.createElement('button');
      prevBtn.className = 'pdm-slider-nav pdm-slider-prev';
      prevBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"></polyline></svg>';
      
      const nextBtn = document.createElement('button');
      nextBtn.className = 'pdm-slider-nav pdm-slider-next';
      nextBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg>';
      
      const dotsContainer = document.createElement('div');
      dotsContainer.className = 'pdm-slider-dots';
      
      imagesArr.forEach((_, idx) => {
        const dot = document.createElement('div');
        dot.className = `pdm-slider-dot ${idx === 0 ? 'active' : ''}`;
        dot.dataset.index = idx;
        dotsContainer.appendChild(dot);
      });
      
      sliderUI.appendChild(prevBtn);
      sliderUI.appendChild(nextBtn);
      sliderUI.appendChild(dotsContainer);
      activeCloneWrapper.appendChild(sliderUI);
      
      // Initial state for buttons
      prevBtn.style.opacity = '0';
      prevBtn.style.pointerEvents = 'none';
      if (imagesArr.length <= 1) {
        nextBtn.style.opacity = '0';
        nextBtn.style.pointerEvents = 'none';
      }

      const updateSlider = (index) => {
        if (index < 0 || index >= imagesArr.length) return;
        currentIndex = index;
        
        prevBtn.style.opacity = currentIndex === 0 ? '0' : '1';
        prevBtn.style.pointerEvents = currentIndex === 0 ? 'none' : 'auto';
        nextBtn.style.opacity = currentIndex === imagesArr.length - 1 ? '0' : '1';
        nextBtn.style.pointerEvents = currentIndex === imagesArr.length - 1 ? 'none' : 'auto';
        
        activeCloneImg.style.opacity = '0';
        setTimeout(() => {
          activeCloneImg.src = imagesArr[currentIndex];
          activeCloneImg.style.opacity = '1';
        }, 150);
        
        dotsContainer.querySelectorAll('.pdm-slider-dot').forEach((d, i) => {
          d.classList.toggle('active', i === currentIndex);
        });
      };
      
      prevBtn.addEventListener('click', (e) => { e.stopPropagation(); updateSlider(currentIndex - 1); });
      nextBtn.addEventListener('click', (e) => { e.stopPropagation(); updateSlider(currentIndex + 1); });
      
      dotsContainer.addEventListener('click', (e) => {
        e.stopPropagation();
        if (e.target.classList.contains('pdm-slider-dot')) {
          updateSlider(parseInt(e.target.dataset.index));
        }
      });
      
      let touchStartX = 0;
      activeCloneWrapper.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, {passive: true});
      
      activeCloneWrapper.addEventListener('touchend', (e) => {
        const touchEndX = e.changedTouches[0].screenX;
        if (touchStartX - touchEndX > 40) updateSlider(currentIndex + 1);
        else if (touchEndX - touchStartX > 40) updateSlider(currentIndex - 1);
      }, {passive: true});
      
      setTimeout(() => {
        sliderUI.style.opacity = '1';
      }, 400);
    }

    // 4. Hide original
    imgWrap.style.opacity = '0';

    // 5. Open modal shell
    const modal = document.getElementById('product-detail-modal');
    const panelInner = document.querySelector('.pdm-panel-inner');
    const pdmContent = document.querySelector('.pdm-content');
    
    if (modal) {
      modal.classList.add('is-active');
      modal.setAttribute('aria-hidden', 'false');
    }
    
    // Initialize Lenis smooth scroll for the description panel
    if (panelInner && typeof Lenis !== 'undefined') {
      panelInner.style.overflowY = 'auto';
      panelInner.style.overflowX = 'hidden';
      panelInner.setAttribute('data-lenis-prevent', 'true');
      // Destroy any previous panel Lenis instance
      if (window._pdmPanelLenis) {
        window._pdmPanelLenis.destroy();
        window._pdmPanelLenis = null;
      }
      window._pdmPanelLenis = new Lenis({
        wrapper: panelInner,
        content: panelInner.firstElementChild,
        lerp: 0.1,
        smoothWheel: true
      });
      function pdmPanelRaf(time) {
        if (window._pdmPanelLenis) {
          window._pdmPanelLenis.raf(time);
          requestAnimationFrame(pdmPanelRaf);
        }
      }
      requestAnimationFrame(pdmPanelRaf);
    }
    
    // 6. Calculate target (FLIP)
    const isMobile = window.innerWidth <= 900;
    
    // On mobile, physically move the thumbnails inside the scrollable text panel
    if (isMobile && thumbsContainer && pdmContent) {
      pdmContent.insertBefore(thumbsContainer, pdmContent.firstChild);
    } else if (thumbsContainer && modal) {
      // On desktop, keep them floating outside the panel
      const layoutWrapper = document.querySelector('.pdm-layout-wrapper') || modal;
      layoutWrapper.insertBefore(thumbsContainer, document.getElementById('pdm-panel'));
    }

    document.body.style.overflow = 'hidden';
    if (typeof lenis !== 'undefined') lenis.stop();

    const targetContainer = document.getElementById('pdm-image-container');
    const targetRect = targetContainer ? targetContainer.getBoundingClientRect() : {
      top: isMobile ? 10 : window.innerHeight * 0.15,
      left: isMobile ? 10 : window.innerWidth * 0.12,
      height: isMobile ? window.innerHeight * 0.50 : window.innerHeight * 0.55,
      width: isMobile ? window.innerWidth - 20 : window.innerHeight * 0.55 * 0.75
    };

    const targetTop = targetRect.top;
    const targetLeft = targetRect.left;
    const targetHeight = targetRect.height;
    const targetWidth = targetRect.width;
    const targetRadius = 16;

    // Animate the clone to target
    if (typeof gsap !== 'undefined') {
      gsap.to(activeCloneWrapper, {
        top: targetTop,
        left: targetLeft,
        width: targetWidth,
        height: targetHeight,
        borderRadius: targetRadius,
        duration: 0.4,
        ease: 'power3.inOut'
      });
    } else {
      activeCloneWrapper.style.top = targetTop + 'px';
      activeCloneWrapper.style.left = targetLeft + 'px';
      activeCloneWrapper.style.width = targetWidth + 'px';
      activeCloneWrapper.style.height = targetHeight + 'px';
      activeCloneWrapper.style.borderRadius = targetRadius + 'px';
      
    }
  });

  // Handle Close
  document.body.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('#pdm-close') || e.target.closest('#pdm-overlay');
    if (!closeBtn || !activeCloneWrapper || !activeCard) return;

    const modal = document.getElementById('product-detail-modal');
    if (modal) {
      modal.classList.remove('is-active');
      modal.setAttribute('aria-hidden', 'true');
    }
    
    document.body.style.overflow = '';
    if (typeof lenis !== 'undefined') lenis.start();

    // Destroy panel Lenis instance
    if (window._pdmPanelLenis) {
      window._pdmPanelLenis.destroy();
      window._pdmPanelLenis = null;
    }

    // Reverse FLIP
    const imgWrap = activeCard.querySelector('.blu-card-img-wrap') || activeCard.querySelector('.flip-img-wrap') || activeCard.querySelector('.blu-sg-img-wrap');
    if (!imgWrap) return;
    const rect = imgWrap.getBoundingClientRect();

    

    if (typeof gsap !== 'undefined') {
      gsap.to(activeCloneWrapper, {
        top: rect.top,
        left: rect.left,
        width: rect.width,
        height: rect.height,
        borderRadius: 16,
        duration: 0.35,
        ease: 'power3.inOut',
        onComplete: () => {
          imgWrap.style.opacity = '1';
          if (activeCloneWrapper) activeCloneWrapper.remove();
          activeCloneWrapper = null;
          activeCard = null;
        }
      });
    } else {
      imgWrap.style.opacity = '1';
      if (activeCloneWrapper) activeCloneWrapper.remove();
      activeCloneWrapper = null;
      activeCard = null;
    }
  });

  // Global Event Delegation for Add to Cart
  document.body.addEventListener('click', async (e) => {
    const addBtn = e.target.closest('#pdm-add-btn');
    if (!addBtn) return;
    
    e.preventDefault();
    e.stopPropagation();

    if (!activeCard) {
      alert("Error: No active card selected.");
      return;
    }
    
    const originalText = addBtn.innerText;
    addBtn.innerText = 'Adding...';
    addBtn.style.opacity = '0.7';
    
    try {
      let variantId = activeCard.dataset.variantId;
      
      const sizeSelector = document.getElementById('pdm-size-selector');
      if (sizeSelector && sizeSelector.style.display !== 'none') {
        const selectedBtn = sizeSelector.querySelector('.pdm-size-btn.selected');
        if (!selectedBtn) {
          alert('Please select a size before adding to cart.');
          addBtn.innerText = originalText;
          addBtn.style.opacity = '1';
          return;
        }
        variantId = selectedBtn.dataset.variantId;
      }
      
      if (!variantId) {
          const handle = activeCard.dataset.id;
          const res = await fetch('/products/' + handle + '.js');
          if (!res.ok) throw new Error('Product not found in Shopify');
          const productData = await res.json();
          variantId = productData.variants[0].id;
      }

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      
      if (!res.ok) throw new Error('Cart Add Failed');
      
      addBtn.innerText = 'Added to Cart ';
      addBtn.style.opacity = '1';
      addBtn.style.background = '#000000';
      addBtn.style.color = '#ffffff';
      
      if (typeof renderCart === 'function') {
          await renderCart();
          document.getElementById('pdm-close')?.click();
          if (typeof openCart === 'function') openCart();
      }

      setTimeout(() => {
        addBtn.innerText = originalText;
        addBtn.style.background = '#ffffff';
        addBtn.style.color = '#000000';
      }, 2000);
    } catch (e) {
      console.error(e);
      alert('Error adding to cart. ' + e.message);
      addBtn.innerText = originalText;
      addBtn.style.opacity = '1';
    }
  });

  })();

  // Seamless Grid Quick Add
  document.body.addEventListener('click', async (e) => {
    const addBtn = e.target.closest('.blu-sg-add');
    if (!addBtn) return;
    
    e.preventDefault();
    e.stopPropagation();

    const card = addBtn.closest('.blu-sg-card');
    if (!card) return;

    let variantId = card.dataset.variantId;
    if (!variantId) {
        const handle = card.dataset.id || card.dataset.name.toLowerCase().replace(/ /g, '-');
        try {
            const res = await fetch(`/products/${handle}.js`);
            const productData = await res.json();
            variantId = productData.variants[0].id;
        } catch(e) {
            console.error('Could not find variant ID');
            return;
        }
    }

    addBtn.style.opacity = '0.5';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!res.ok) throw new Error('Cart Add Failed');
      
      addBtn.style.opacity = '1';
      
      if (typeof renderCart === 'function') {
          await renderCart();
          if (typeof openCart === 'function') openCart();
      }
    } catch(err) {
      console.error(err);
      alert('Error adding to cart: ' + err.message);
      addBtn.style.opacity = '1';
    }
  });

/* ============================================================
   SEARCH OVERLAY  Predictive Search
   ============================================================ */
(() => {
  const toggleBtn = document.getElementById('search-toggle-btn');
  const overlay = document.getElementById('otc-search-overlay');
  const backdrop = document.getElementById('otc-search-backdrop');
  const closeBtn = document.getElementById('otc-search-close');
  const input = document.getElementById('otc-search-input');
  const resultsContainer = document.getElementById('otc-search-results');
  if (!toggleBtn || !overlay || !input) return;

  let debounceTimer = null;

  function openSearch() {
    overlay.classList.add('is-active');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => input.focus(), 100);
  }
  function closeSearch() {
    overlay.classList.remove('is-active');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    input.value = '';
    resultsContainer.innerHTML = '';
  }

  toggleBtn.addEventListener('click', openSearch);
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);
  if (backdrop) backdrop.addEventListener('click', closeSearch);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.classList.contains('is-active')) closeSearch();
  });

  input.addEventListener('input', () => {
    clearTimeout(debounceTimer);
    const q = input.value.trim();
    if (q.length < 2) {
      resultsContainer.innerHTML = '';
      return;
    }
    debounceTimer = setTimeout(() => fetchResults(q), 250);
  });

  async function fetchResults(query) {
    try {
      const res = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,page,article&resources[limit]=8`
      );
      if (!res.ok) return;
      const data = await res.json();
      renderResults(data.resources.results, query);
    } catch (err) {
      console.error('Search error:', err);
    }
  }

  function renderResults(results, query) {
    let html = '';
    const products = results.products || [];
    const pages = results.pages || [];
    const articles = results.articles || [];

    if (products.length === 0 && pages.length === 0 && articles.length === 0) {
      html = `<div class="otc-search-empty">No results for "${escHtml(query)}"</div>`;
      resultsContainer.innerHTML = html;
      return;
    }

    if (products.length > 0) {
      html += '<span class="otc-search-group-label">Products</span>';
      products.forEach(p => {
        const imgSrc = p.image ? p.image : '';
        const price = p.price ? ('\u20b9' + parseFloat(p.price).toLocaleString('en-IN')) : '';
        html += `
          <a href="/pages/shop-all?otc_prod=${p.handle}" class="otc-search-item" data-handle="${p.handle}">
            ${imgSrc ? `<img class="otc-search-item-img" src="${imgSrc}" alt="" loading="lazy">` : ''}
            <div class="otc-search-item-info">
              <div class="otc-search-item-title">${escHtml(p.title)}</div>
              ${price ? `<div class="otc-search-item-meta">${price}</div>` : ''}
            </div>
            <svg class="otc-search-item-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><polyline points="9 18 15 12 9 6"/></svg>
          </a>`;
      });
    }

    if (pages.length > 0) {
      html += '<span class="otc-search-group-label">Pages</span>';
      pages.forEach(p => {
        html += `
          <a href="${p.url}" class="otc-search-item">
            <div class="otc-search-item-info">
              <div class="otc-search-item-title">${escHtml(p.title)}</div>
              <div class="otc-search-item-meta">Page</div>
            </div>
            <svg class="otc-search-item-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><polyline points="9 18 15 12 9 6"/></svg>
          </a>`;
      });
    }

    if (articles.length > 0) {
      html += '<span class="otc-search-group-label">Articles</span>';
      articles.forEach(a => {
        html += `
          <a href="${a.url}" class="otc-search-item">
            <div class="otc-search-item-info">
              <div class="otc-search-item-title">${escHtml(a.title)}</div>
              <div class="otc-search-item-meta">Article</div>
            </div>
            <svg class="otc-search-item-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><polyline points="9 18 15 12 9 6"/></svg>
          </a>`;
      });
    }

    resultsContainer.innerHTML = html;
  }

  function escHtml(str) {
    const d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  // Intercept clicks on search results to scroll smoothly if we are already on shop-all
  resultsContainer.addEventListener('click', (e) => {
    const item = e.target.closest('.otc-search-item');
    if (!item || !item.dataset.handle) return;
    
    const handle = item.dataset.handle;
    if (window.location.pathname.includes('/pages/shop-all')) {
      e.preventDefault();
      closeSearch();
      const card = document.querySelector(`.js-flip-trigger[data-id="${CSS.escape(handle)}"], .blu-card[data-id="${CSS.escape(handle)}"]`);
      if (card) {
        if (window.lenis) {
          window.lenis.scrollTo(card, { offset: -100, duration: 1.2 });
          setTimeout(() => card.click(), 1200);
        } else {
          card.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(() => card.click(), 600);
        }
      } else {
        openFakeCard(handle);
      }
    }
  });

  window.openFakeCard = function(handle) {
    fetch(`/products/${handle}.js`)
      .then(res => res.json())
      .then(product => {
        const fakeCard = document.createElement('div');
        fakeCard.className = 'js-flip-trigger';
        fakeCard.style.position = 'fixed';
        fakeCard.style.top = '50%';
        fakeCard.style.left = '50%';
        fakeCard.style.width = '100px';
        fakeCard.style.height = '100px';
        fakeCard.style.opacity = '0';
        fakeCard.style.pointerEvents = 'none';
        
        fakeCard.dataset.id = product.handle;
        fakeCard.dataset.name = product.title;
        fakeCard.dataset.priceStr = '\u20b9' + (product.price / 100).toLocaleString('en-IN');
        fakeCard.dataset.desc = product.description;
        
        if (product.variants) {
          const sizes = product.variants.map(v => ({ id: v.id, name: v.title, available: v.available }));
          fakeCard.dataset.sizes = JSON.stringify(sizes);
        }
        if (product.images) {
          fakeCard.dataset.images = JSON.stringify(product.images);
        }
        
        const imgWrap = document.createElement('div');
        imgWrap.className = 'blu-card-img-wrap';
        const img = document.createElement('img');
        img.className = 'blu-card-img--front';
        img.src = (product.images && product.images[0]) ? product.images[0] : '';
        
        imgWrap.appendChild(img);
        fakeCard.appendChild(imgWrap);
        document.body.appendChild(fakeCard);
        
        // Let DOM update slightly, then trigger FLIP
        setTimeout(() => fakeCard.click(), 50);
      })
      .catch(err => console.warn('Could not load fake card product data', err));
  };
})();

/* ============================================================
   SHARE BUTTON  Copy product deep-link to clipboard
   ============================================================ */
document.addEventListener('DOMContentLoaded', () => {
  const shareBtn = document.getElementById('pdm-share-btn');
  if (!shareBtn) return;

  const originalIcon = shareBtn.innerHTML;

  shareBtn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    const handle = window.__otcActiveProductHandle;
    if (!handle) return;

    // Build deep-link URL pointing to the current page with ?product=handle
    const url = new URL(window.location.href);
    url.searchParams.set('otc_prod', handle);
    url.hash = '';
    const shareUrl = url.toString();

    // Attempt modern clipboard API first
    let copied = false;
    
    // Create textarea for synchronous fallback (fixes iOS/Safari strict user-gesture requirements)
    const ta = document.createElement('textarea');
    ta.value = shareUrl;
    ta.style.cssText = 'position:fixed;opacity:0;top:0;left:0;pointer-events:none;';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    
    try {
      if (document.execCommand('copy')) {
        copied = true;
      }
    } catch (err) {}
    
    ta.remove();

    if (copied) {
      showCheckmark();
    } else if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(shareUrl).then(() => showCheckmark()).catch(e => console.error(e));
    }
  });

  function showCheckmark() {
    shareBtn.innerHTML = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>`;
    setTimeout(() => {
      shareBtn.innerHTML = originalIcon;
    }, 2000);
  }
});

/* ============================================================
   DEEP LINK  Auto-open product modal from ?product=handle
   ============================================================ */
(() => {
  const params = new URLSearchParams(window.location.search);
  const productHandle = params.get('otc_prod');
  if (!productHandle) return;

  // Wait for DOM to fully render, then find and click the matching product card
  window.addEventListener('load', () => {
    const card = document.querySelector(
      `.js-flip-trigger[data-id="${CSS.escape(productHandle)}"], .blu-card[data-id="${CSS.escape(productHandle)}"]`
    );
    
    if (card) {
      // Give the page's entry preloader time to fade out, then smooth scroll
      setTimeout(() => {
        if (window.lenis) {
          window.lenis.scrollTo(card, { offset: -100, duration: 1.2 });
          setTimeout(() => card.click(), 1200);
        } else {
          card.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(() => card.click(), 800);
        }
      }, 600);
      
      // URL parameter remains, which is fine (if they refresh, it pops up again)
    } else {
      // Product not found on current page (likely paginated or lazy-loaded)
      // Fetch it directly from Shopify API to build a fake card and trigger the popup
      setTimeout(() => {
        if (window.openFakeCard) {
          window.openFakeCard(productHandle);
        }
      }, 800); // Give preloader time to fade
      // URL parameter remains
    }
  });
})();

